import { useDebounceFunc } from "client/hooks/utils/useDebounceFunc";
import { useWindowSize } from "client/hooks/utils/useWindowSize";
import { processAdsOnPage } from "client/utils/ads/processAdsOnPage";
import { destroyAds } from "client/utils/ads/destroyAds";
import { useEffect, useRef, useState } from "react";

export const useFixedEditorLayout = () => {
    const { width } = useWindowSize();
    const bottomMenuRef = useRef<HTMLDivElement>(null);

    const resizeDebounce = useDebounceFunc();
    const [isLandscape, setIsLandscape] = useState(false);

    const handleResize = () => {
        resizeDebounce(() => {
            setIsLandscape((isLandscape) => {
                const _isLandscape = window.innerHeight < window.innerWidth;
                if (!_isLandscape && isLandscape) {
                    destroyAds();
                    processAdsOnPage();
                }
                return _isLandscape;
            });
        });
    };

    useEffect(() => {
        if (width > 768) return;
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return { width, bottomMenuRef, isLandscape };
};

